import React, { useState } from 'react';
import FooterModal from './FooterModal';
import logo from "../media3/header/skinforge.png";

import Visa from "../media3/footer/visa.png";
import Mastercard from "../media3/footer/mastercard.webp";
// import Discover from "../media3/footer/discover.png";
import UnionPay from "../media3/footer/unionpay.png";
import JCB from "../media3/footer/jcb.png";
import SSL from "../media3/footer/ssl.png";
// import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalTitle, setModalTitle] = useState('');

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      setMessage('Please enter a valid email address.');
      return;
    }
    setMessage('Thank you for registering!');
    setEmail('');
    setTimeout(() => setMessage(''), 3000);
  };

  const handleClick = () => {
    const upcomingSkinsSection = document.getElementById('homepage-section');
    if (upcomingSkinsSection) {
      upcomingSkinsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openModal = (content, title) => {
    setModalContent(content);
    setModalTitle(title);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent('');
    setModalTitle('');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-left">
            <h1 className="footer-title">
              SKINFORGE. POWER UP YOUR INVENTORY
            </h1>
          </div>
          <div className="footer-right">
            <div className="email-signup">
              <input
                type="email"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="email-input"
              />
              <button onClick={handleSubmit} className="signup-button">
                Register →
              </button>
            </div>
            {message && (
              <div className="register-message">{message}</div>
            )}
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-info">
                <div className="logo">
                  <img src={logo} alt="Logo" /> 
                 </div>
            <p className="brand-description">
              Your premium destination for buying skins.<br />
              No trading. No waiting. Just instant<br />
              ownership.
            </p>
          </div>
          <nav className="footer-nav">
            <a href="/" className="nav-link" onClick={handleClick}>HOME</a>
            <a href="/categories" className="nav-link" onClick={handleClick}>CATEGORIES</a>
            <a href="/contact" className="nav-link" onClick={handleClick}>CONTACT US</a>
          </nav>

          <div className="cards-images">
							<img className="card-logo" src={Visa} alt="" />
							<img className="card-logo" src={Mastercard} alt="" />
							<img className="card-logo" src={JCB} alt="" />
							<img className="card-logo" src={UnionPay} alt="" />
							<img className="card-logo" src={SSL} alt="" />
						</div>
        </div>
        <div className='footer-nav-categories'>
          <h4>ALL CATEGORIES : </h4>
             <a href="/categories/pistols"  onClick={handleClick}>Pistols</a>
            <a href="/categories/rifle" onClick={handleClick}>Rifles</a>
            <a href="/categories/mid-tier"  onClick={handleClick}>Mid-Tier</a>
             <a href="/categories/knives"  onClick={handleClick}>Knives</a>
            <a href="/categories/gloves" onClick={handleClick}>Gloves</a>
            <a href="/categories/cases"  onClick={handleClick}>Cases</a>
            <a href="/categories/stickers" onClick={handleClick}>Stickers</a>
        </div>
        
      </div>
      <div className="footer-legal">
        <div className="copyright">
          © 2025 SkinForge. ALL RIGHTS RESERVED.
        </div>
        <FooterModal openModal={openModal} />
        <div className="social-icons">
          <a href="https://x.com/" className="social-link" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img">
            <path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.3 4.3 0 0 0 1.88-2.37 8.59 8.59 0 0 1-2.72 1.04 4.28 4.28 0 0 0-7.29 3.9A12.15 12.15 0 0 1 3.15 4.6a4.28 4.28 0 0 0 1.32 5.72 4.25 4.25 0 0 1-1.94-.54v.05a4.28 4.28 0 0 0 3.44 4.2 4.3 4.3 0 0 1-1.93.07 4.28 4.28 0 0 0 3.99 2.97A8.6 8.6 0 0 1 2 19.54a12.13 12.13 0 0 0 6.56 1.92c7.87 0 12.18-6.52 12.18-12.18 0-.19 0-.37-.01-.56A8.7 8.7 0 0 0 24 5.1a8.48 8.48 0 0 1-2.54.7z"/>
          </svg>
            
          </a>
          <a href="https://www.instagram.com/" className="social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
          </a>
          <a href="https://www.facebook.com/" className="social-link" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9.101 23.691v-7.98H6.627v-3.667h2.474v-1.58c0-4.085 1.848-5.978 5.858-5.978.401 0 .955.042 1.468.103a8.68 8.68 0 0 1 1.141.195v3.325a8.623 8.623 0 0 0-.653-.036 26.805 26.805 0 0 0-.733-.009c-.707 0-1.259.096-1.675.309a1.686 1.686 0 0 0-.679.622c-.258.42-.374.995-.374 1.752v1.297h3.919l-.386 3.667h-3.533v7.98H9.101z"/>
            </svg>
          </a>
        </div>
      </div>

      {modalOpen && (
        <div className="term-modal-overlay">
          <div className="term-modal">
            <div className="term-modal-header">
              <h2>{modalTitle}</h2>
              <button onClick={closeModal} className="term-modal-close-button">×</button>
            </div>
            <div className="term-modal-content" dangerouslySetInnerHTML={{ __html: modalContent }} />
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;